import { render, staticRenderFns } from "./GeneralInventoryWithPackingBreakdownReport.vue?vue&type=template&id=07355373&"
import script from "./GeneralInventoryWithPackingBreakdownReport.vue?vue&type=script&lang=js&"
export * from "./GeneralInventoryWithPackingBreakdownReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports